import { ChartSettingsShowOptions } from './chart-settings-show-options.enum';

export const RatioChartViewVariants = [
  {
    label: 'Pie chart',
    value: ChartSettingsShowOptions.PieChart,
  },
  {
    label: 'Vertical bar chart',
    value: ChartSettingsShowOptions.VerticalBar,
  },
  {
    label: 'Horizontal bar chart',
    value: ChartSettingsShowOptions.HorizontalBar,
  },
];
